import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useLazyQuery } from '@apollo/client';
import { CREATE_CAMPAIGN_NAME } from '../../../gql/campaign/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GET_PROFILE } from '../../../gql/auth/queries';
import Loaders from 'react-loader-spinner';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"



function CampaignName({ history }) {

    const [errorMessage, setErrorMessage] = useState('')
    const [campaignError, setCampaignError] = useState(false);


    const [getProfile, { loading: profileLoading }] = useLazyQuery(GET_PROFILE, {
        onCompleted(data) {
            if (data?.me?.emailProvider == null) {
                history.push('/dashboard')
            }
        }
    })
    const [createCampaignName, { loading }] = useMutation(CREATE_CAMPAIGN_NAME, {
        onError(error) {
            if (error) {
                if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
                    setErrorMessage("Check Your Network, Your Browser Is Offline")
                }
                if (error.message) {
                    setErrorMessage(error.message)
                }
                if (!error.message) {
                    setErrorMessage("Something Went Wrong !")
                }
            }
        }
    });

    useEffect(() => {
        getProfile()
        //eslint-disable-next-line
    }, [])


    const formik = useFormik({
        initialValues: {
            campaignName: "",
        },
        validationSchema: Yup.object({
            campaignName: Yup.string()
                .required("Campaign name is required"),
        }),
        enableReinitialize: true,
        onSubmit: (values) => {

            try {
                if (!values.campaignName || !values.campaignName.trim()) {
                    formik.errors.campaignName = 'Campaign name is required';
                    return setCampaignError(true);

                    //   return toast.error("Campaign Name Is Required.", {
                    //     position: "bottom-right",
                    //   })

                }

            }
            catch (e) {
                console.error(e)
            }
        }
    })

    const countChars = () => {
        document.getElementById("charNum").innerHTML = formik.values.campaignName.length + ' / 50';
    }

    if (profileLoading) {
        return <div className="spinner" >
            <Loaders
                type="ThreeDots"
                color="#192f60"
                height={70}
                width={70}
                timeout={3000}
            />
        </div>
    }

    if (errorMessage) {
        toast.error(errorMessage, {
            position: "bottom-right",
        })
        setErrorMessage('')
    }

    const handleUploadLeads = async () => {
        if (!formik.values.campaignName || !formik.values.campaignName.trim()) {
            formik.errors.campaignName = 'Campaign name is required';
            setCampaignError(true);
        }
        else {
            try {
                let { data } = await createCampaignName({
                    variables: {
                        campaignInput: {
                            campaignName: formik.values.campaignName,
                        }
                    }
                })

                if (data) {
                    history.push(`/campaigns/uploadleads/${data.createCampaign?.campaignId}`)
                }
            }
            catch (error) {
                console.error(error)
            }
        }
    }

    const handleSkipLeads = async () => {
        if (!formik.values.campaignName || !formik.values.campaignName.trim()) {
            formik.errors.campaignName = 'Campaign name is required';
            setCampaignError(true);
        }
        else {
            try {
                let { data } = await createCampaignName({
                    variables: {
                        campaignInput: {
                            campaignName: formik.values.campaignName,
                        }
                    }
                })

                if (data) {
                    history.push(`/campaignOption/${data.createCampaign?.campaignId}`)
                }
            }
            catch (error) {
                console.error(error)
            }
        }
    }

    return (
        <div className='create-campaign-screen'>
            <div className="back-btn-div">
                <Link to='/dashboard'>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.75" d="M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM17 7L1 7L1 9L17 9L17 7Z" fill="#0A1E43" />
                    </svg>
                    Back to dashboard
                </Link>
            </div>
            <div className='create-title'>
                <h4>Create a new campaign</h4>
            </div>
            <div className='campiagn-form-wrap'>
                <Form className="campaignForm" onSubmit={formik.handleSubmit}>
                    <ul className='campaign-form-steps'>
                        <li className="first-li" >
                            <Form.Group className='input-wrap campaign-name' controlId="campaignName">
                                <Form.Label>Name of your Campaign *</Form.Label>
                                <Form.Control
                                    name="campaignName"
                                    type="text"
                                    placeholder=""
                                    value={formik.values.campaignName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength="50"
                                    onKeyUp={countChars}
                                    className={formik.errors.campaignName && formik.touched.campaignName && "error"}
                                    style={{ borderTop: 'none', borderLeft: 'none', borderRight: 'none' }}
                                />
                                {formik.errors.campaignName && formik.touched.campaignName && (
                                    <div className="input-feedback">{formik.errors.campaignName}</div>
                                )}
                                {!formik.touched.campaignName && campaignError && <div className="input-feedback">{formik.errors.campaignName}</div>}
                                <span id="charNum">0 / 50</span>
                            </Form.Group>

                            <div className='btn-container'>
                                {
                                    loading ?
                                        <button type="button" disabled className='solid-button'  >Upload Leads </button>
                                        :
                                        <button type="button" className='solid-button' onClick={handleUploadLeads} >Upload Leads</button>
                                }
                                {
                                    loading ?
                                        <button className='solid-button' type="button" id="autoGenerate" disabled >Skip Leads</button>
                                        :
                                        <button className='solid-button' type="button" id="autoGenerate" onClick={handleSkipLeads} >Skip Leads</button>

                                }
                            </div>
                        </li>
                    </ul>
                </Form>
            </div>
        </div>
    )
}

export default withRouter(CampaignName)
